/**
 * Valida senha conforme política e retorna { valid, errors, rules } para exibição.
 * policy: { minLength, maxLength, requireSpecialChar, requireUppercase, requireLowercase, requireNumber }
 */
export function validatePasswordForPolicy(password, policy) {
  if (!policy) return { valid: false, errors: [], rules: [] };
  const min = Math.max(4, Number(policy.minLength) || 6);
  const max = Math.min(32, Number(policy.maxLength) || 32);
  const len = (password || '').length;
  const pwd = password || '';
  const errors = [];
  const rules = [
    { label: `Entre ${min} e ${max} caracteres`, ok: len >= min && len <= max },
    ...(policy.requireSpecialChar ? [{ label: 'Pelo menos um caractere especial', ok: /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(pwd) }] : []),
    ...(policy.requireUppercase ? [{ label: 'Pelo menos uma letra maiúscula', ok: /[A-Z]/.test(pwd) }] : []),
    ...(policy.requireLowercase ? [{ label: 'Pelo menos uma letra minúscula', ok: /[a-z]/.test(pwd) }] : []),
    ...(policy.requireNumber ? [{ label: 'Pelo menos um número', ok: /[0-9]/.test(pwd) }] : []),
  ];
  if (len > 0 && len < min) errors.push(`Mínimo de ${min} caracteres.`);
  if (len > max) errors.push(`Máximo de ${max} caracteres.`);
  if (policy.requireSpecialChar && !/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(pwd)) errors.push('Exige pelo menos um caractere especial.');
  if (policy.requireUppercase && !/[A-Z]/.test(pwd)) errors.push('Exige pelo menos uma letra maiúscula.');
  if (policy.requireLowercase && !/[a-z]/.test(pwd)) errors.push('Exige pelo menos uma letra minúscula.');
  if (policy.requireNumber && !/[0-9]/.test(pwd)) errors.push('Exige pelo menos um número.');
  const valid = errors.length === 0 && len >= min && len <= max;
  return { valid, errors, rules };
}
